import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
// LIBS
import { Subscription } from 'rxjs';
// COMPONENTS
import { UIMultimediaDialog } from '@shared/components/multimedia-dialog/multimedia-dialog';
import { NativePaginator } from '@shared/modules/native/paginator/paginator';
// SERVICES
import { NodeService } from '@services/node/node.service';
import { AlertService } from '@services/notification/alert.service';
import { AuthenticationConfigurationService } from '@services/authentication/authentication-configuration.service';
// MODELS
import { FileType } from '@models/file-type/FileType';
import { Multimedia, MultimediaContent } from '@models/Multimedia';
import { Node } from '@models/node/Node';
import { PageEvent } from '@shared/modules/native/paginator/paginator-config';
import { Response } from '@models/response-api/ResponseApi';
// CONST / CONFIG
import { Content, MinifiedContent } from '@models/content/Content';
import { FILE_TYPE } from '@constants/FileType';
import { getFileTypeByUrl } from '@utils/url';
import { ResourceService } from '@services/resource/resource.service';

// TODO : TAG GTM
declare var dataLayer: any;

@Component({
	selector: 'app-multimedia',
	templateUrl: './multimedia.component.html',
	styleUrls: ['./multimedia.component.scss'],
})
export class MultimediaComponent implements OnInit, OnDestroy {
	subscription = new Subscription();
	@ViewChild(NativePaginator) paginator!: NativePaginator;
	displayedColumns: string[] = ['iconLabel', 'name', 'action'];
	dataSource: MinifiedContent[] = [];
	total = 0;
	isFirst = true;
	isFirstLoadingData = true;
	node!: Node;
	rol: string;
	@Input() isBachillerato = false;
	@Input() canDownloadFile = false;
	@Input() grade = 0;
	@Input() signature = 0;
	@Input() subsystem = 0;
	@Input()
	fileType!: FileType;
	@Input()
	set filters(value: any) {
		if (this.isFirst) {
			this.isFirst = false;
			this.node = this.createConfigNode(value.subsystemId, value.nodeId);
		} else {
			this.node.nodeId = value.nodeId;
		}
		this.loadData();
	}
	cct: string | null = '';
	typeSchool: string | null = '';
	constructor(
		private dialog: MatDialog,
		private nodeService: NodeService,
		private alertService: AlertService,
		private authConfigService: AuthenticationConfigurationService,
		public rs: ResourceService
	) {
		this.rol = this.authConfigService.getUser().rol;
	}

	ngOnInit() {
		this.cct = localStorage.getItem('cct');
		this.typeSchool = localStorage.getItem('typeSchool');
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	get showLink() {
		return this.fileType.id === FILE_TYPE.digitalTextBooks;
	}

	showLinkExternalFile(item: Content) {
		return getFileTypeByUrl(item.urlContent) == FILE_TYPE.interactive;
	}

	showMessageEmpty() {
		return !this.isFirstLoadingData && this.dataSource.length === 0;
	}

	createConfigNode(subsystemId: number, nodeId: number): Node {
		return {
			subsystemId,
			nodeId,
			fileTypeId: this.fileType.id,
			filter: null,
			currentPage: 1,
			sizePage: 10,
		};
	}

	search(value: string) {
		this.node = { ...this.node, filter: value, currentPage: 1 };
		this.loadData();
	}

	clearFilters() {
		this.node = { ...this.node, filter: null, currentPage: 1 };
		this.loadData();
	}

	changePage($event: PageEvent) {
		const { pageIndex } = $event;
		this.node = { ...this.node, currentPage: pageIndex + 1 };
		this.loadData();
	}

	loadData() {
		const filterContent = sessionStorage.getItem('filterContent');
		const option = sessionStorage.getItem('filterOption');

		this.subscription.add(
			this.nodeService
				.getAllContentsV2(this.node)
				.subscribe({
					next: (x: Response) => {
						this.total = x.pagination?.total || 0;
						const { files } = x.data || {};

						this.dataSource = files as MinifiedContent[];

						dataLayer.push({
							event: 'filter_usage', //Static data
							content_group: 'Recursos digitales', //Dynamic data
							filter: option, //Dynamic data
							value: filterContent, //Dynamic data
							results: this.dataSource.length, //Dynamic data
							cct: this.cct, //Dynamic data
							school_type: this.typeSchool,
						});

						let url = '';

						for (let a of this.dataSource) {
							url = a.urlContent.replace(/\s+/g, ''); // Elimina espacios en blanco
							url = url.replace(/\n/g, ''); // Elimina saltos de línea

							a.urlContent = url;
						}

						this.eventLoadResources();
					},
					error: (error: HttpErrorResponse) => {
						this.alertService.showSmallErrorServer();
					},
				})
				.add(() => {
					this.isFirstLoadingData = false;
				})
		);
	}

	showResource(content: MinifiedContent) {
    debugger;
		let level = '';
		switch (this.node.nodeId) {
			case 143:
				level = 'Primaria';
				break;
			case 144:
				level = 'Preescolar';
				break;
			case 145:
				level = 'Secundaria';
				break;
			case 1448:
				level = 'Bachillerato';
				break;
			default:
				break;
		}

		dataLayer.push({
			event: 'select_content_file', //Static data
			account_type: this.rol, //Dynamic data
			content_group: 'Recursos digitales', //Dynamic data
			level: level, //Dynamic data
			grade: this.grade, //Dynamic data
			//subject: content.educationLevelDescription, //Dynamic data
			content_name: content.name, //Dynamic data
			content_type: content.fileTypeDesc, //Dynamic data
			content_id: content.id, //Dynamic data
			cct: this.cct, //Dynamic data
			school_type: this.typeSchool,
		});
		const multimedia: MultimediaContent = {
			data: content,
			showButtonDownload: this.canDownloadFile,
			nodeId: this.signature,
			grade: this.grade,
			subsystem: this.subsystem,
		};
		this.dialog.open(UIMultimediaDialog, {
			data: multimedia,
			backdropClass: ['ui-backdropClass'],
			panelClass: ['ui-panelClass'],
			maxWidth: '900px',
			minWidth: '420px',
			width: '765px',
		});
		this.eventOpenSource(content);
	}

	eventLoadResources() {
		let level = '';
		switch (this.node.nodeId) {
			case 143:
				level = 'Primaria';
				break;
			case 144:
				level = 'Preescolar';
				break;
			case 145:
				level = 'Secundaria';
				break;
			case 1448:
				level = 'Bachillerato';
				break;
			default:
				break;
		}

		dataLayer.push({
			event: 'view_content_list_file', //Static data
			account_type: this.rol, //Dynamic data
			content_group: 'Recursos digitales', //Dynamic data
			level: level, //Dynamic data
			grade: 0, //Dynamic data
			subject: this.rol, //Dynamic data
			content_name: this.fileType.description, //Dynamic data
			content_type: this.fileType.description, //Dynamic data
			content_id: '', //Dynamic data
			result: this.dataSource.length, //Dynamic data
			cct: this.cct, //Dynamic data
			school_type: this.typeSchool,
		});
	}

	eventOpenSource(content: MinifiedContent) {
		let level = '';
		switch (this.node.nodeId) {
			case 143:
				level = 'Primaria';
				break;
			case 144:
				level = 'Preescolar';
				break;
			case 145:
				level = 'Secundaria';
				break;
			case 1448:
				level = 'Bachillerato';
				break;
			default:
				break;
		}

		dataLayer.push({
			event: 'select_content_resource', //Static data
			account_type: this.rol, //Dynamic data
			content_group: 'Recursos digitales', //Dynamic data
			level: level, //Dynamic data
			grade: 3, //Dynamic data
			subject: this.rol, //Dynamic data
			content_name: content.name, //Dynamic data
			content_type: content.fileTypeDesc, //Dynamic data
			content_list_id: content.id, //Dynamic data
			cct: this.cct, //Dynamic data
			school_type: this.typeSchool,
		});
	}

	downloadFile(resource: MinifiedContent) {
		this.rs.downloadContent(resource);
	}
}
